import React from "react";
import elephantImage from "../../../assets/Elephant1.jpg";
import "./elephant.css";

class Elephant extends React.Component {
  render() {
    return (
      <div className="parallax-container">
        <div className="parallax-image">
          <img src={elephantImage} alt="Elephant" className="image-element" />
        </div>
        <div className="content"></div>
      </div>
    );
  }
}

export default Elephant;
